import { forwardRef, type ReactElement, type Ref } from 'react';

export interface PopoverTriggerProps {
  children(props: { ref: Ref<HTMLElement> }): ReactElement;
}

export const PopoverTrigger = forwardRef<HTMLElement, PopoverTriggerProps>(
  ({ children }, ref) => children({ ref }),
);

PopoverTrigger.displayName = 'PopoverTrigger';
